<template>
  <div id="app" class="w-100 h-100" v-if="!loading">
    <div class="app-container app-width d-flex flex-column h-100">
      <div class="app-body" style="overflow: hidden">
        <perfect-scrollbar
          class="h-100"
          @ps-scroll-y="onScrollY"
          ref="pageScroll"
        >
          <TitleBar />
          <router-view />
          <input type="hidden" id="inputCopy" />
        </perfect-scrollbar>
      </div>
      <ToolBar ref="toolbar" />
    </div>
    <slideout-panel />
  </div>
</template>

<script>
import ToolBar from "@/components/app/ToolBar";
import TitleBar from "@/components/app/TitleBar";
import homeService from "@/services/homeService";
import authenticateService from "@/services/authenticateService";

export default {
  name: "App",
  components: { ToolBar, TitleBar },
  data: () => ({
    loading: true,
  }),
  methods: {
    onScrollY() {
      const ps = this.$refs.pageScroll.ps;
      if (
        ps.containerHeight + this.$refs.pageScroll.$el.scrollTop >=
        ps.contentHeight
      )
        this.$bridge.$emit("scrollToBottom");
    },
    async loginByAccessToken(accessToken) {
      await this.$recaptchaLoaded();
      const result = await authenticateService.loginByAccessToken(
        accessToken,
        await this.$recaptcha("loginByAccessToken")
      );

      this.loading = false;
      if (!result || result.error) return;

      const data = result.data;
      await this.$store.dispatch("setAccount", data.account);
      await this.$store.dispatch("setAccessToken", accessToken);
      await this.$store.dispatch("setGiftCodesForYou", null);
      if (data.hasNewNotification)
        this.$bridge.$emit("hasNewNotification", true);
    },
  },
  async created() {
    const params = new URL(document.location.toString()).searchParams;
    const accessToken = params.get("accessToken");
    if (accessToken?.length) await this.loginByAccessToken(accessToken);
    else this.loading = false;

    const result = await homeService.getCurrentTime();
    if (result && !result.error)
      await this.$store.dispatch("setCurrentTime", new Date(result.data));
  },
};
</script>
